export default __webpack_public_path__ + "static/media/Packleader Jerkin.23905644.jpg";